import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useBoolean } from '@fluentui/react-hooks';
import { Call16Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';

// models
import { PhoneViewModel } from '../../../models/Entities/Person/Phone/PhoneModels';

// components
import PersonPhoneFormComponent from './PersonPhone.Form.Component';
import { PersonContactList } from '../PersonContactList/PersonContactList.Component';

// functions
import * as ComponentFunctions from './PersonPhones.List.Functions';

/** Teléfonos de la persona: grupo compacto de la tarjeta de contacto, con alta, edición y baja. */
const PersonPhonesListComponent = (props: ComponentFunctions.Props) => {
  const [t] = useTranslation();
  const [isFormOpen, { setTrue: openForm, setFalse: dismissForm }] = useBoolean(false);
  const [selectedPhoneId, setSelectedPhoneId] = useState<number | undefined>(undefined);

  const load = () => { if (props.PersonId) props.GetPhonesByPersonId(props.PersonId); };
  useEffect(() => { load(); }, [props.PersonId]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <PersonContactList<PhoneViewModel>
        testId="person-phones"
        title={t('persons.phones.list.count', { defaultValue: 'Teléfonos' })}
        icon={<Call16Regular />}
        items={props.phones}
        primary={(phone) => phone.phoneNumber || '—'}
        itemLabel={(phone) => phone.phoneNumber || ''}
        isLoading={props.isLoading}
        failOnLoading={props.failOnLoading}
        isDeleting={props.isDeleting}
        failOnDeleting={props.failOnDeleting}
        error={props.error}
        addLabel={t('persons.phones.list.add', { defaultValue: 'Agregar teléfono' })}
        emptyText={t('persons.phones.list.empty', { defaultValue: 'No hay teléfonos registrados' })}
        loadingLabel={t('persons.phones.list.loading', { defaultValue: 'Cargando teléfonos...' })}
        loadErrorTitle={t('persons.phones.list.error', { defaultValue: 'No fue posible obtener los teléfonos' })}
        deleteTitle={t('persons.phones.list.deleteTitle', { defaultValue: 'Eliminar teléfono' })}
        deleteText={(phone) => t('persons.phones.list.deleteText', { defaultValue: 'Se va a eliminar el teléfono {{phone}}. Esta acción no se puede deshacer.', phone: phone.phoneNumber })}
        onAdd={() => { setSelectedPhoneId(undefined); openForm(); }}
        onEdit={(phone) => { setSelectedPhoneId(phone.id); openForm(); }}
        onDelete={(phone) => props.DeletePhone(phone.id)}
        onRetry={load}
      />
      <PersonPhoneFormComponent
        isOpen={isFormOpen}
        openPanel={openForm}
        dismissPanel={() => { setSelectedPhoneId(undefined); dismissForm(); }}
        PersonId={props.PersonId}
        phoneId={selectedPhoneId}
      />
    </>
  );
};

export default connect(
  ComponentFunctions.mapStateToProps,
  ComponentFunctions.mapDispatchToProps
)(PersonPhonesListComponent as any);
